
export interface IPublicTypeI18nMap {
  [lang: string]: { [key: string]: string };
}
